import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseService } from '../../_services/';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private _firebase : FirebaseService,
    private _router : Router
  ) { }

  ngOnInit() {
  }

  logout(){
    localStorage.removeItem('uid');
    this._firebase.SignOut();
    this._router.navigateByUrl("/login", { skipLocationChange: true })
      .then(() => this._router.navigate([""]));
  }

}
